import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family';

const ResearchFamilyNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusPage.displayName =
  'Research Family Notifications CivilStatusPage component';

export default ResearchFamilyNotificationsCivilStatusPage;
